import axios from "axios";
import { getApiBaseUrl } from "src/config/endpoints";
import { normalizeApiLang, type ApiLang } from "src/utils/apiLang";
import { getApiKey, getTenantId } from "src/utils/getters";

const API_BASE_URL = getApiBaseUrl();

export interface PipelineRefresh {
  pipeline_uuid: string;
  last_run_completed_at: string;
  source: string; // ✅ new field from backend
}

export const getPipelineRefreshTime = async (): Promise<PipelineRefresh[]> => {
  const tenant_id = getTenantId();
  const api_key = getApiKey();

  if (!tenant_id || !api_key) {
    throw new Error("Missing tenant ID or API key in localStorage");
  }

  const response = await axios.get(
    `${API_BASE_URL}/mage/get-pipelines-run-time`,
    {
      params: {
        tenant_id,
        api_key,
      },
    }
  );

  return response.data;
};

// Cancel data loading
export const cancelDataLoading = async (tenant_id: string, api_key: string) => {
  const response = await axios.post(
    `${API_BASE_URL}/tenant/cancel-data-load?tenant_id=${tenant_id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${api_key}`,
      },
    }
  );

  return response;
};

function langForDashboardRequest(lang?: string | null | ApiLang): ApiLang {
  if (lang !== undefined && lang !== null) {
    return normalizeApiLang(lang);
  }
  if (typeof window === "undefined") {
    return "en";
  }
  return normalizeApiLang(window.localStorage.getItem("i18nextLng"));
}

// Fetch shopify data loading status
export const fetchShopifyDataStatus = async (
  tenant_id: string,
  api_key: string,
  lang?: string | null | ApiLang
) => {
  const searchParams = new URLSearchParams({
    tenant_id,
    lang: langForDashboardRequest(lang),
  });
  const response = await fetch(
    `${API_BASE_URL}/shopify/fetched-data-status?${searchParams.toString()}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${api_key}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch shopify data status");
  }

  const data = await response.json();
  return data;
};
